export default "__VITE_ASSET__7vGiLyCL__"